import React from 'react'
import NuevaOrden from '../components/NuevaOrden';

const orden = () => {
  return (
    <NuevaOrden />
  )
}

export default orden